import enterprise from './enterprise/store';
import org from './org/store';
import orgs from './orgs/store';
import subOrg from './sub-org/store';
import user from './user/store';
import role from './role/store';
import members from './members/store';
import service from './service/store';

export default {
  namespaced: true,
  modules: { enterprise, org, orgs, subOrg, user, role, members, service },
};
